import i18n from "i18next";

const resources = {
  ar: {
    name: "الاسم",
    active: "نشط",
    active_status: "نشط",
    inactive_status: "غير نشط",
    version: "الإصدار",
    submissions: "الإرسالات",
    customForms: "النماذج المخصصة",
    add_new_form: "إضافة نموذج جديد",
    search_forms: "البحث في النماذج",
    of: "من",
    updated_at: "تم التحديث",
    created_at: "تم الإنشاء",
    rows: "صفوف",
    updated_successfully: "تم التحديث بنجاح",
    multiple_submissions_allowed: "السماح بتقديمات متعددة",
    submissions_total: "إجمالي التقديمات",
    submitted: "تم التقديم",
    yes: "نعم",
    no: "لا",
    submitted_count_format: "تم التقديم ({{n}} من {{m}})",
    total_sent: "إجمالي المُرسل",
    total_draft: "المسودات",
    total_submitted: "المكتملة"
  },
  en: {
    name: "Name",
    active: "Active",
    active_status: "Active",
    inactive_status: "Inactive",
    version: "Version",
    submissions: "Submissions",
    customForms: "Custom Forms",
    add_new_form: "Add New Form",
    search_forms: "Search Forms",
    of: "OF",
    updated_at: "Updated At",
    created_at: "Created At",
    rows: "Rows",
    updated_successfully: "Updated successfully",
    multiple_submissions_allowed: "Multiple Submissions",
    submissions_total: "Total Submissions",
    submitted: "Submitted",
    yes: "Yes",
    no: "No",
    submitted_count_format: "Submitted ({{n}} of {{m}})",
    total_sent: "Sent",
    total_draft: "Draft",
    total_submitted: "Submitted"
  },
  fr: {
    name: "Nom",
    active: "Actif",
    active_status: "Actif",
    inactive_status: "Inactif",
    version: "Version",
    submissions: "Soumissions",
    customForms: "Formulaires personnalisés",
    add_new_form: "Ajouter un nouveau formulaire",
    search_forms: "Rechercher des formulaires",
    of: "DE",
    updated_at: "Mis à jour le",
    created_at: "Créé le",
    rows: "Lignes",
    updated_successfully: "Mis à jour avec succès",
    multiple_submissions_allowed: "Soumissions multiples autorisées",
    submissions_total: "Total des soumissions",
    submitted: "Soumis",
    yes: "Oui",
    no: "Non",
    submitted_count_format: "Soumis ({{n}} sur {{m}})",
    total_sent: "Envoyé",
    total_draft: "Brouillon",
    total_submitted: "Soumis"
  },
  it: {
    name: "Nome",
    active: "Attivo",
    active_status: "Attivo",
    inactive_status: "Inattivo",
    version: "Versione",
    submissions: "Invii",
    customForms: "Moduli personalizzati",
    add_new_form: "Aggiungi nuovo modulo",
    search_forms: "Cerca moduli",
    of: "DI",
    updated_at: "Aggiornato il",
    created_at: "Creato il",
    rows: "Righe",
    updated_successfully: "Aggiornato con successo",
    multiple_submissions_allowed: "Invii multipli consentiti",
    submissions_total: "Totale invii",
    submitted: "Inviato",
    yes: "Sì",
    no: "No",
    submitted_count_format: "Inviato ({{n}} di {{m}})",
    total_sent: "Inviato",
    total_draft: "Bozza",
    total_submitted: "Completato"
  },
  ckb: { // Sorani Kurdish
    name: "ناو",
    active: "چالاک",
    active_status: "چالاک",
    inactive_status: "ناچالاک",
    version: "وەشان",
    submissions: "پێشکەشکردنەکان",
    customForms: "فۆڕمە تایبەتەکان",
    add_new_form: "فۆڕمی نوێ زیاد بکە",
    search_forms: "گەڕان لە فۆڕمەکان",
    of: "لە",
    updated_at: "نوێکراوە لە",
    created_at: "دروستکرا لە",
    rows: "ڕیز",
    updated_successfully: "بە سەرکەوتوویی نوێکرایەوە",
    multiple_submissions_allowed: "ڕێگەدان بە پێشکەشکردنی فرە",
    submissions_total: "کۆی پێشکەشکردنەکان",
    submitted: "پێشکەشکراو",
    yes: "بەڵێ",
    no: "نەخێر",
    submitted_count_format: "پێشکەشکراو ({{n}} لە {{m}})",
    total_sent: "نێردراو",
    total_draft: "ڕەشنووس",
    total_submitted: "تەواوکراو"
  },
  ku: { // Kurmanji Kurdish
    name: "Nav",
    active: "Çalak",
    active_status: "Çalak",
    inactive_status: "Neçalak",
    version: "Wersiyon",
    submissions: "Şandin",
    customForms: "Forma Taybet",
    add_new_form: "Forma nû zêde bike",
    search_forms: "Lêgerîn di formên de",
    of: "JI",
    updated_at: "Nûve kirin li",
    created_at: "Afirandina li",
    rows: "Rêz",
    updated_successfully: "Bi serkeftî nûve kir",
    multiple_submissions_allowed: "Destûr dayîna şandina pir",
    submissions_total: "Tevahiya şandinê",
    submitted: "Şandî",
    yes: "Erê",
    no: "Na",
    submitted_count_format: "Şandî ({{n}} ji {{m}})",
    total_sent: "Şandî",
    total_draft: "Reşnivîs",
    total_submitted: "Temamkirî"
  },
  el: {
    name: "Όνομα",
    active: "Ενεργό",
    active_status: "Ενεργό",
    inactive_status: "Ανενεργό",
    version: "Έκδοση",
    submissions: "Υποβολές",
    customForms: "Προσαρμοσμένες φόρμες",
    add_new_form: "Προσθήκη νέας φόρμας",
    search_forms: "Αναζήτηση φορμών",
    of: "ΤΟΥ",
    updated_at: "Ενημερώθηκε στις",
    created_at: "Δημιουργήθηκε στις",
    rows: "Γραμμές",
    updated_successfully: "Ενημερώθηκε με επιτυχία",
    multiple_submissions_allowed: "Πολλαπλές υποβολές επιτρέπονται",
    submissions_total: "Συνολικές υποβολές",
    submitted: "Υποβλήθηκε",
    yes: "Ναι",
    no: "Όχι",
    submitted_count_format: "Υποβλήθηκε ({{n}} από {{m}})",
    total_sent: "Απεσταλμένα",
    total_draft: "Πρόχειρα",
    total_submitted: "Ολοκληρωμένα"
  },
  nl: {
    name: "Naam",
    active: "Actief",
    active_status: "Actief",
    inactive_status: "Inactief",
    version: "Versie",
    submissions: "Inzendingen",
    customForms: "Aangepaste formulieren",
    add_new_form: "Nieuw formulier toevoegen",
    search_forms: "Formulieren zoeken",
    of: "VAN",
    updated_at: "Laatst bijgewerkt op",
    created_at: "Gemaakt op",
    rows: "Rijen",
    updated_successfully: "Succesvol bijgewerkt",
    multiple_submissions_allowed: "Meerdere inzendingen toegestaan",
    submissions_total: "Totaal inzendingen",
    submitted: "Ingediend",
    yes: "Ja",
    no: "Nee",
    submitted_count_format: "Ingediend ({{n}} van {{m}})",
    total_sent: "Verzonden",
    total_draft: "Concept",
    total_submitted: "Voltooid"
  },
  pl: {
    name: "Nazwa",
    active: "Aktywny",
    active_status: "Aktywny",
    inactive_status: "Nieaktywny",
    version: "Wersja",
    submissions: "Przesłane",
    customForms: "Formularze niestandardowe",
    add_new_form: "Dodaj nowy formularz",
    search_forms: "Szukaj formularzy",
    of: "Z",
    updated_at: "Zaktualizowano dnia",
    created_at: "Utworzono dnia",
    rows: "Wiersze",
    updated_successfully: "Zaktualizowano pomyślnie",
    multiple_submissions_allowed: "Wiele zgłoszeń dozwolonych",
    submissions_total: "Łączne zgłoszenia",
    submitted: "Przesłane",
    yes: "Tak",
    no: "Nie",
    submitted_count_format: "Przesłane ({{n}} z {{m}})",
    total_sent: "Wysłane",
    total_draft: "Szkic",
    total_submitted: "Ukończone"
  },
};

export const addTranslationResources = (i18next: typeof i18n) => {
  i18next.addResourceBundle("ar", "custom-forms", resources.ar);
  i18next.addResourceBundle("en", "custom-forms", resources.en);
  i18next.addResourceBundle("fr", "custom-forms", resources.fr);
  i18next.addResourceBundle("it", "custom-forms", resources.it);
  i18next.addResourceBundle("ckb", "custom-forms", resources.ckb);
  i18next.addResourceBundle("ku", "custom-forms", resources.ku);
  i18next.addResourceBundle("el", "custom-forms", resources.el);
  i18next.addResourceBundle("nl", "custom-forms", resources.nl);
  i18next.addResourceBundle("pl", "custom-forms", resources.pl);
};
